/**
 * This is a "bridge" that allows redux actions to interact with the application notifications context,
 * i.e. open different notifications e.g. toasts, overlayBanners, etc. from within redux actions.
 *
 * It works by holding onto a reference of the applicationNotifications context, which is set from the
 * AuctionApp container, and then allowing redux actions to get this reference and use it.
 */

let notificationsContext

export const setApplicationNotificationsContext = context => {
  notificationsContext = context
}

export const getApplicationNotificationsContext = () => notificationsContext
